import { BaseDestinationItem } from '@/features/destinations/commons';
import { CustomConnectorDto } from '@/models/connectors';
import { FC, PropsWithChildren } from 'react';

type CustomConnectorDestinationItemProps = {
  connector: CustomConnectorDto;
} & PropsWithChildren;

export const CustomConnectorDestinationItem: FC<CustomConnectorDestinationItemProps> = ({ connector, children }) => {
  const image = connector.authConfiguration?.configurations?.[0]?.elements?.auth?.config?.['image'];
  const connectorWithIcon = {
    ...connector,
    icon: image ? `data:image/png;base64,${image}` : '/assets/icons/default-connector.svg',
  };

  return (
    <BaseDestinationItem connector={connectorWithIcon}>
      {children}
    </BaseDestinationItem>
  );
};
